import http from './index';

export const setCurrentUserLang = async (values) => http.patch('/users/current', values);
